export default {
  'new': 'New',
  'queued': 'Queued',
  'in_progress': 'In Progress',
  'failed': 'Failed',
  'done': 'Done',
};